<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-2">
            <!-- Card stats -->
            <div class="row pt-md-4">
                <div class="col-md-12">
                    <h1>RIPEMD160 Hash Converter</h1>
                </div>

                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.input"
                               placeholder="Enter Value"/>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.output"
                               placeholder="Result RIPEMD160"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-lg-12">
                    <button class="btn btn-dark" @click="calc"><i class="ni ni-sound-wave"></i> Convert</button>
                    <button class="btn btn-primary" @click="clean"><i class="ni ni-button-power"></i> Clear Data
                    </button>
                    <button v-if="values.output" class="btn btn-info"
                            v-clipboard:copy="values.output"
                            v-clipboard:success="onCopy">
                        <i class="ni ni-ungroup"></i> Copy Result
                    </button>
                </div>
            </div>

        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--8 bg-dark pb-4">

            <!--Tables-->
            <div class="row mt-5">
                <div class="col-xl-12 mb-12 mb-xl-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Latest Results</h3>
                                </div>
                                <div class="col text-right">

                                </div>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <base-table thead-classes="thead-light"
                                        :data="tableData">
                                <template slot="columns">
                                    <th>In</th>
                                    <th>Input Data</th>
                                    <th>Out</th>
                                    <th>Output Data</th>

                                </template>

                                <template slot-scope="{row}">
                                    <th scope="row">
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.input"
                                                v-clipboard:success="onCopy">
                                            {{row.inType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </th>
                                    <th scope="row">
                                        {{row.input}}
                                    </th>
                                    <td>
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.output"
                                                v-clipboard:success="onCopy">
                                            {{row.outType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </td>
                                    <td style="overflow-x:auto;">
                                        {{row.output}}
                                    </td>

                                </template>

                            </base-table>
                        </div>

                    </div>

                    <div v-if="!this.$root.mobile" class="card shadow mt-4 pl-2 pt-2 pb-2 pr-2 bg-gradient-neutral">
                        <h1>RIPEMD</h1>
                        <p>
                            RIPEMD (RIPE Message Digest) is a family of cryptographic hash functions developed in 1992
                            (the original RIPEMD) and 1996 (other variants). There are five functions in the family:
                            RIPEMD, RIPEMD-128, RIPEMD-160, RIPEMD-256, and RIPEMD-320, of which RIPEMD-160 is the most
                            common.
                        </p>
                        <p>
                            The original RIPEMD, as well as RIPEMD-128, is not considered secure because 128-bit result
                            is too small and also (for the original RIPEMD) because of design weaknesses. The 256- and
                            320-bit versions of RIPEMD provide the same level of security as RIPEMD-128 and RIPEMD-160,
                            respectively; they are designed for applications where the security level is sufficient but
                            longer hash result is necessary.
                            While RIPEMD functions are less popular than SHA-1 and SHA-2, they are used, among others,
                            in Bitcoin and other cryptocurrencies based on Bitcoin.
                        </p>
                    </div>
                </div>
            </div>
            <!--End tables-->
        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'

    Vue.use(VueClipboard);
    import CryptoJS from 'crypto-js';

    export default {
        name: "RipeMd160",
        directives: {
            'b-tooltip': BTooltipDirective
        },
        data() {
            return {
                values: {
                    input: null,
                    output: null
                },
                tableData: [],
            };
        },
        methods: {
            onCopy() {
                this.$notify({
                    type: 'success',
                    title: 'Copied to clipboard'
                })
            },
            revert: function () {

            },
            clean: function () {
                this.values.output = null;
                this.values.input = null;
                this.tableData = [];
            },
            calc: function () {
                if (this.values.input) {
                    this.values.output = (CryptoJS.RIPEMD160(this.values.input)).toString()
                    this.tableData.unshift({
                        input: this.values.input,
                        inType: "string",
                        output: this.values.output,
                        outType: "ripemd160",
                    });

                    if (this.tableData.length > 8) {
                        this.tableData.splice(8, 1);
                    }
                }
            }
        },
        mounted() {

        }
    };
</script>
<style></style>
